import { render, staticRenderFns } from "./teamCustomized.vue?vue&type=template&id=10b9c41b&scoped=true&"
import script from "./teamCustomized.vue?vue&type=script&lang=js&"
export * from "./teamCustomized.vue?vue&type=script&lang=js&"
import style0 from "./teamCustomized.vue?vue&type=style&index=0&id=10b9c41b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9c41b",
  null
  
)

export default component.exports